var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "show_mobile card" },
      [
        _c(
          "b-row",
          { staticClass: "text-center p-1", attrs: { "align-h": "center" } },
          _vm._l(
            _vm.projects.filter((r) => r.name == "Daily Productivity Report"),
            function (p) {
              return _c(
                "div",
                { key: p.name },
                [
                  _c(
                    "b-row",
                    { staticClass: "pb-1", attrs: { "align-v": "center" } },
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function ($event) {
                                  return _vm.$emit("loadProject", p.name)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(p.name) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }
          ),
          0
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }